import {
  Button,
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { AccountCountryType } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { OnboardingScreenParamList } from "../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useFormContext } from "react-hook-form";
import { OnboardingFormValues } from "../components";
import { useTranslation } from "react-i18next";

const options = [
  {
    label: "Australia",
    value: AccountCountryType.AUSTRALIA,
    description:
      "Your business is based in Australia. Relevant information will be displayed such as ABN, GST, Cash Rounding demonination will be changed to 0.05, etc.",
  },
  {
    label: "New Zealand",
    value: AccountCountryType.NEW_ZEALAND,
    description:
      "Your business is based in New Zealand. Relevant information will be displayed such as GST, Cash Rounding demonination will be changed to 0.10, etc.",
  },
];

export type OnBoardingSelectCountryScreenProps = NativeStackScreenProps<
  OnboardingScreenParamList,
  "OnBoardingSelectCountryScreen"
>;

export const OnBoardingSelectCountryScreen = ({
  navigation,
}: OnBoardingSelectCountryScreenProps) => {
  const { t } = useTranslation("onboarding");

  const { setValue, watch } = useFormContext<OnboardingFormValues>();

  const selectedCountry = watch("countryType");

  const handleOnSelect = (countryType: AccountCountryType) => {
    setValue("countryType", countryType);
  };

  const items: FlatActionListItem[] = React.useMemo(() => {
    return options.map((option) => ({
      id: option.value,
      key: option.value,
      title: option.label,
      bordered: true,
      subTitle: option.description,
      onPress: () => {
        handleOnSelect(option.value);
      },
      componentRight: () => null,
      selected: selectedCountry === option.value,
    }));
  }, [selectedCountry]);

  const disabled = !selectedCountry;

  const footerMarkup = (
    <Button
      disabled={disabled}
      label={t("button.continue_onboarding")}
      isAction
      color="white"
      onPress={() => {
        navigation.navigate("OnboardingConfirmDetailsScreen");
      }}
    ></Button>
  );

  return (
    <Page
      footer={footerMarkup}
      title={t("select_country_title")}
      secondaryTitle={t("select_country_secondary_text")}
    >
      <FlatActionList items={items} />
    </Page>
  );
};
